import React from 'react';
import './banner.css';

const Banner = () => {
  return (
    <div className="banner">
          <img className="banner-img"src="https://n.vodafone.ie/content/dam/gowingmyself/promotions/brands/apple/iphone14-pro-max-lineup.png" alt="Banner Image" />  
          <div className="banner-text">
          <h1>NEVER OVERSPEND ON TECH AGAIN</h1>
          <h2>Shop ElliTech</h2>
        </div>
      </div>
  );
}

export default Banner;
